import Display from './Display';
import OrientationAdjustment from './OrientationAdjustment';
import Gallery from './Gallery';
import { ToolID } from '../shared/common';

interface ToolPanelProps {
  tool: ToolID;
}

const ToolPanel = ({ tool }: ToolPanelProps) => {
  const createSubPage = (tool: ToolID) => {
    switch (tool) {
      case ToolID.Display:
        return <Display />;

      case ToolID.OrientationAdjustment:
        return <OrientationAdjustment />;

      case ToolID.Gallery:
        return <Gallery />;

      default:
        return <div></div>;
    }
  };

  return <>{createSubPage(tool)}</>;
};

export default ToolPanel;
